import { DataManager } from "../model/DataManager.js";
import { VOCategory } from "../model/DataStructure.js";
import { Language, LanguageCode } from "../model/Language.js";

export class CategorySelector {
    public onSelectCategory = e5.Signal.create<[VOCategory]>();

    public element: HTMLDivElement;

    private _category: VOCategory = null;
    private _list: HTMLDivElement;
    private _items: CategorySelectorItem[] = [];
    private _current: CategorySelectorItem = null;
    private _control: HTMLDivElement;

    constructor(private _data: DataManager) {

        this.element = document.createElement("div");
        this.element.classList.add("category-selector");
        this.element.innerHTML = `
        <div class="category-selector-list"></div>
        <div class="category-selector-control"></div>`;

        this._list = this.element.querySelector(".category-selector-list");
        this._control = this.element.querySelector(".category-selector-control");

        // this.addIconButton("icon-770");

        if (this._data.config.show_language_control) {
            this.addLanguageButton("de", "main.language-control-de");
            this.addLanguageButton("en", "main.language-control-en");
        }

        if (this._data.config.show_fullscreen_buttons
            && this._data.config.fullscreen_button_positions.indexOf("main_control") !== -1) {
            this.addFullscreenButton();
        }

        for (var category of this._data.config.categories) {
            if (category.videos.length == 0) {
                continue;
            }
            var item = new CategorySelectorItem(category);
            this._items.push(item);
            this._list.appendChild(item.element);
        }

        this.category = this._data.config.categories[0];

        $(this.element).on("click", "[data-categoryid]", (e) => {
            var categoryId = parseInt(e.currentTarget.getAttribute("data-categoryid"));
            var category = this._data.config.categories.id(categoryId);
            if (category) {
                this.category = category;
            }
        });

        this.updateVisibility();

        Language.onChange.add((language) => {
            this.updateVisibility();
        });
    }

    private addFullscreenButton(): void {
        var btn = document.createElement("div");
        btn.className = `category-selector-list-item icon-button full`;
        btn.innerHTML = `<span class="full icon-756"></span><span class="normal icon-757"></span>`;
        this._control.appendChild(btn);
        btn.addEventListener("click", () => {
            document.body.classList.toggle("fullscreen");
        });
    }

    private addIconButton(icon: string): void {
        var btn = document.createElement("div");
        btn.className = `category-selector-list-item icon-button`;
        btn.innerHTML = `<span class="${icon}"></span>`;
        this._control.appendChild(btn);
    }

    private addLanguageButton(language: LanguageCode, uiLabelKey: string): void {
        var btn = document.createElement("div");
        btn.className = `category-selector-list-item language-button ${Language.current == language ? "active" : ""}`;
        btn.setAttribute("data-lang", language);
        // btn.textContent = label;
        Language.label(btn, uiLabelKey);
        this._control.appendChild(btn);
    }

    public reset(): void {
        this.category = this._data.config.categories[0];
    }

    public set category(value: VOCategory) {
        if (!value || this._category == value) {
            return;
        }
        if (this._current) {
            this._current.active = false;
        }

        this._category = value;
        this._current = this.getItem(value);

        if (this._current) {
            this._current.active = true;
        }

        this.onSelectCategory.dispatch(this._category);
    }

    public get category(): VOCategory {
        return this._category;
    }

    private getItem(category: VOCategory): CategorySelectorItem {
        for (var item of this._items) {
            if (category == item.category) {
                return item;
            }
        }
        return null;
    }

    private updateVisibility(): void {
        for (var item of this._items) {
            item.visible = item.category.videos.filter((video) => {
                if (video.languages != "all") {
                    return video.languages == Language.current;
                }
                return true;
            }).length > 0;
        }

        if (this._current && !this._current.visible) {
            this.category = this._data.config.categories[0];
        }
    }
}

class CategorySelectorItem {
    public element: HTMLDivElement;

    constructor(public category: VOCategory) {
        this.element = document.createElement("div");
        this.element.className = "category-selector-list-item";
        this.element.setAttribute("data-categoryid", category.id + "");
        Language.apply(this.element, category.label_de, category.label_en);
    }

    public get visible(): boolean {
        return !this.element.classList.contains("hidden");
    }

    public set visible(value: boolean) {
        this.element.classList.toggle("hidden", !value);
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(value: boolean) {
        this.element.classList.toggle("active", value);
    }
}